import { Component, input, output } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { FunctionInterface } from '@vendasta/ai-assistants';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'ai-functions-list',
  imports: [MatCard, MatCardContent, MatIcon, MatIconButton],
  templateUrl: './ai-functions-list.component.html',
  styleUrls: ['./ai-functions-list.component.scss', '../../ai-assistant-configuration/ai-assistant-shared.scss'],
})
export class AiFunctionsListComponent {
  readonly functions = input.required<FunctionInterface[]>();
  readonly remove = output<string>();
  readonly edit = output<string>();
}
